import React, { useState, useEffect } from 'react';
import { isEmpty } from "lodash";
import { securityFilter } from '../../../../../utils/securityFilter';
import useCrypto from '../../../../customHooks/crypto';
import validator from 'validator';
import Loader from '../../../../../setup/Loader/LoaderIndicator';
import { Link } from "react-router-dom";
import SocialLogin from '../SocialAuth/SocialLogin';
import useLangTranslation from '../../../../customHooks/languageProvider';
import AuthTermsService from '../../../../shared/Components/AuthTermsService';
import AuthSignUp from '../../../../shared/Components/AuthSignUp';
import useAuthentication from '../../../../customHooks/authentication';

const Login = () => {
  const [inputFields, setInputFields] = useState([
    { type: 'email', name: 'email', labelText: 'LOGIN_CHILD_EMAIL', labelValue: 'email', id: 'email', placeholder: 'LOGIN_CHILD_EMAIL', value: '', error: '', errValue: '' },
    { type: 'password', name: 'password', labelText: 'LOGIN_CHILD_PASSWORD', labelValue: 'password', id: 'password', placeholder: 'LOGIN_CHILD_PASSWORD', value: '', error: '', errValue: '' }
  ]);

  const { getLangTranslation } = useLangTranslation();
  const { socialSignInData, setSocialSignInData, loader, loginApi } = useAuthentication();
  const { encryptRequest } = useCrypto();

  function credntialsValidate() {
    if (inputFields[0]['error'] || inputFields[1]['error']) {
      return false;
    }

    let flag = true;
    if (isEmpty(inputFields[0]['value'])) {
      const inputFieldsTemp = [...inputFields];
      inputFieldsTemp[0]['error'] = 'SIGN_UP_EMAIL_IS_REQUIRED_ERR';
      inputFieldsTemp[0]['errValue'] = 'Email is required';
      setInputFields(inputFieldsTemp);
      flag = false;
    }

    if (isEmpty(inputFields[1]['value'])) {
      const inputFieldsTemp = [...inputFields];
      inputFieldsTemp[1]['error'] = 'PASSWORD_IS_REQUIRED';
      inputFieldsTemp[1]['errValue'] = 'Password is required';
      setInputFields(inputFieldsTemp);
      flag = false;
    }

    return flag;
  }

  function isSecurityCheckPassed() {
    if (inputFields[0]['value'] && !securityFilter(inputFields[0]['value'])) {
      return false;
    }
    return true;
  }

  function handleLoginClick() {
    if (!credntialsValidate()) {
      return;
    }
    if (!isSecurityCheckPassed()) {
      const inputFieldsTemp = [...inputFields];
      inputFieldsTemp[0]['error'] = 'SPECIAL_CHAR_NOT_ALLOWED_ERR';
      inputFieldsTemp[0]['error'] = 'Special characters are not allowed';
      setInputFields(inputFieldsTemp);
      return;
    }

    const email = encryptRequest(inputFields[0]['value'])?.content;
    const password = encryptRequest(inputFields[1]['value'])?.content;
    loginApi(email, password, null);
  }

  function handeInputChange(e) {
    const name = e.target.name;
    const value = e.target.value;
    const tempInputFields = [...inputFields];

    if (name === 'email' && value && !validator.isEmail(value)) {
      tempInputFields[0]['error'] = "EMAIL_FORMAT_NOT_VALID_ERR"
      tempInputFields[0]['errValue'] = "Email format is not valid"
    } else if (name === 'email' && validator.isEmail(value)) {
      tempInputFields[0]['error'] = ""
    }

    tempInputFields.forEach((item, index) => {
      if (item?.name === name) {
        tempInputFields[index]['value'] = value
        tempInputFields[index]['error'] = ''
      }
    })

    setInputFields(tempInputFields);
  }

  function handlePwdDisplayToggle() {
    const tempInputFields = [...inputFields];

    if (tempInputFields[1]['type'] === 'text') {
      tempInputFields[1]['type'] = 'password'
    } else {
      tempInputFields[1]['type'] = 'text'
    }

    setInputFields(tempInputFields);
  }

  useEffect(() => {
    if (socialSignInData) {
      const email = encryptRequest(socialSignInData?.email)?.content;
      const socialLoginData = {
        name: socialSignInData?.name,
        picture: socialSignInData?.picture
      };
      if (!socialSignInData?.graphDomain) {
        /* Google SignIn */
        socialLoginData['socialLoginId'] = socialSignInData?.sub
        socialLoginData['locale'] = socialSignInData?.locale
      } else {
        /* Facebook SignIn */
        socialLoginData['socialLoginId'] = socialSignInData?.userID
      }
      loginApi(email, null, socialLoginData);
    }
  }, [socialSignInData]);

  function handleKeyPress(event) {
    if (event.key === 'Enter' && !event.shiftKey) {
      // Prevent default behavior of Enter key
      event.preventDefault();
      // Call the submit function if Enter is pressed without Shift
      handleLoginClick();
    }
  }

  return (
    <>
      <div className="container">
        <div className="auth-wrapper">
          <div className="auth-inner">
            <h2 className="text-center mb-6">{getLangTranslation('ONBOARD_WELCOME', 'Welcome to Kido Protect')}</h2>
            <form>
              {
                inputFields?.map((item, index) => {
                  if (item?.type === 'email') {
                    return (
                      <div className="mb-6" key={index}>
                        <label
                          htmlFor={item?.type}
                          className="form-label"
                        >
                          {getLangTranslation(item?.labelText, item?.labelValue)}
                        </label>
                        <input
                          type={item?.type}
                          name={item?.type}
                          className="form-control"
                          id={item?.type}
                          value={item?.value}
                          placeholder={getLangTranslation(item?.placeholder, item?.labelValue)}
                          onChange={handeInputChange}
                          onKeyDown={handleKeyPress}
                          autoComplete='username'
                        />
                        {item?.error && <div className="field-error">{getLangTranslation(item?.error, item?.errValue)}</div>}
                      </div>
                    )
                  } else {
                    return (
                      <div className="mb-3" key={index}>
                        <label
                          htmlFor={item?.type}
                          className="form-label"
                        >
                          {getLangTranslation(item?.labelText, item?.labelValue)}
                        </label>
                        <div className="input-group">
                          <input
                            className="form-control"
                            type={item?.type}
                            id={item?.name}
                            name={item?.name}
                            placeholder={getLangTranslation(item?.placeholder, item?.labelValue)}
                            value={item?.value}
                            onChange={handeInputChange}
                            onKeyDown={handleKeyPress}
                            autoComplete='current-password'
                          />
                          <span className="input-group-text pt-cursor" onClick={handlePwdDisplayToggle}>
                            {
                              item?.type === 'password' ? (
                                <i className="fa fa-eye-slash" id="togglePassword"></i>
                              ) : (
                                <i className="fa fa-eye" id="togglePassword"></i>
                              )
                            }
                          </span>
                        </div>
                        {item?.error && <label className='field-error'>{getLangTranslation(item?.error, item?.errValue)}</label>}
                      </div>
                    )
                  }
                })
              }
            </form>
            <div className="text-end mb-4">
              <Link to="/auth/forgot-password">{getLangTranslation('LOGIN_CHILD_FORGOT_PASSWORD', 'Forgot Password?')}</Link>
            </div>
            <div className="d-grid">
              <button
                type="button"
                className="btn btn-primary btn-block"
                onClick={handleLoginClick}
              >
                {
                  !loader ? <span className="btn-upper-case text-white">{getLangTranslation('LOGIN_BTN_TEXT', 'Log In')}</span> : (
                    <Loader height={20} width={100} />
                  )
                }
              </button>
            </div>
            <p className="text-center my-6 light-text text-uppercase">{getLangTranslation('LOGIN_SIGN_IN_VIA', 'Log in via')?.replace('Sign', 'Login')}</p>

            <SocialLogin
              setSocialSignInData={setSocialSignInData}
            />

            <AuthSignUp />
            <AuthTermsService />
          </div>
        </div>
      </div>
    </>
  )
}

export default Login;